/*
 * @Author: 朱占伟
 * @LastEditors: 朱占伟
 * @description: 路由配置文件
 * @Date: 2021-10-18 16:07:21
 * @LastEditTime: 2022-03-15 14:59:19
 */

import asyncImport from "utils/asyncComponent"
import homeIndex from 'views/home'

export default [{
  path: '/',
  name: 'homeIndex',
  component: homeIndex,
  exact: true,
  meta: {
    title: 'Howso@ALGO - 零门槛玩转AI开发'
  }
},
{
  path: '/algorithmDetails/:algoId',
  name: 'algorithmDetails',
  component: asyncImport(() => import('views/algorithmDetails/index')),
  meta: {
    title: '详情 - Howso@ALGO - 零门槛玩转AI开发'
  }
},
//算法列表
{
  path: '/algorithmList',
  name: 'algorithmList',
  component: asyncImport(() => import('views/algorithmList/index')),
  meta: {
    title: '解决方案 - Howso@ALGO - 零门槛玩转AI开发'
  }
},
//协同中心
{
  path: '/collaborationCenter',
  name: 'collaborationCenter',
  component: asyncImport(() => import('views/collaborationCenter/index')),
},
// {
//   path: '/404',
//   name: '404',
//   component: asyncImport(() => import('views/error/404')),
//   exact: true,
// },
{
  name: 'other',
  redirect: '/',
  exact: true,
},
]